<div class="title">
  <span *ngIf="!title">Pesquisa de {{searchTypeName}}</span>
  <span *ngIf="title">{{title}}</span>
  <button mat-icon-button class="search-button" [ngClass]="{invert: searchVisible}" (click)="toggleVisibility()">
    <mat-icon>filter_list</mat-icon>
  </button>
</div>


<form *ngIf="searchVisible" [ngClass]="{'search-form-grid': ENTITY_TYPES.length > 1}" [@searchbar] [formGroup]="form"
  (keydown.enter)="$event.preventDefault()">

  <mat-form-field class="full-width form-field" *ngIf="ENTITY_TYPES.length > 1">
    <mat-label>Tipo de entidade</mat-label>
    <mat-select [gioEnableControl]="!searching && ENTITY_TYPES.length > 1" formControlName="entityType">
      <mat-option *ngFor="let item of ENTITY_TYPES" [value]="item.id">
        {{item.value}}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <mat-form-field class="full-width form-field">
    <input matInput [gioEnableControl]="!searching" formControlName="term" placeholder="Termos da pesquisa"
      (keyup.enter)="search()">
    <mat-icon matSuffix (click)="search()" class="pointer">search</mat-icon>
  </mat-form-field>

</form>

<div *ngIf="!searching" class="result-content">
  <ng-container class="result-content" *ngIf="results$ | async as entities">
    <div *ngIf="!searching && entities && entities.length > 0" class="results">
      <gio-entity-card-basic [@cards] *ngFor="let entity of entities" [entity]="entity" imageSize="64"
        [selectable]="true" (onSelect)="clicked(entity)" class="pointer">
        <span entity-content *ngIf="entity.email" class="w-100 text-center d-block">{{entity.email}}</span>
      </gio-entity-card-basic>
    </div>

    <div *ngIf="!searching && entities && entities.length == 0" class="results">
      Nenhum resultado localizado
    </div>

  </ng-container>




</div>

<div class="result-content" *ngIf="searching">
  <gio-loading-page mode="ball" [title]="searching"></gio-loading-page>
</div>


<div class="actions">
  <button mat-raised-button (click)="cancel()">CANCELAR</button>
</div>
